@if (content) {
<div class="fill flex-column bg-col-w col-b off-canvas-body"
     [ngStyle]="{'height' : client.isCms ? '100vh' : '100%'}">
    <div class="pos-relative flex-column flex-grow overflow-hidden">
        <!-- level 1 -->
        <div class="flex-grow flex-column flex-justify-between overflow-y-auto scrolling-touch"
             zippyGroupClass="ng-hide"
             [zippyName]="uid">
            <div>
                <div class="p-l p-r p-t-3 pos-relative">
                    <off-canvas-search [searchId]="'offcanvas'"
                                       class="w-11 p-r-3"></off-canvas-search>
                    <button class="pos-absolute top-7 right-5"
                            type="button"
                            [attr.aria-label]="'Close' | translate"
                            (click)="hideOffCanvas()">
                        <i class="icon-close s2"
                           aria-hidden="true"></i>
                    </button>
                </div>
                <div class="ng-hide-animate">
                    @for (tab of tabs; track tab) {
                    <ul class="p-a menu">
                        @for (item of tab.menu; track item; let i = $index) {
                        <href
                              [link]="item.secondLevelTurnOn && item.secondLevelItems?.length ? undefined : item.link">
                            <li class="p-t-5 p-b b-b b-col-4 flex flex-middle flex-justify-between"
                                [gtmTrackNavigationClick]="{
                                        event: 'nav_category_click',
                                        nav_category: item.text,
                                        link_url: item.link,
                                        link_text: item.text}"
                                [ngClass]="item.color ? item.color : 'col-1'"
                                [zippyOpenOff]="!(client.isCms || (item.secondLevelTurnOn && item.secondLevelItems?.length))"
                                [zippyOpen]="[uid, i]">
                                <span class="p1"
                                      *iCms="'text' of item">
                                </span>
                                @if (item.secondLevelItems?.length) {
                                <i class="icon-chevron-right col-12 p-r-2"
                                   [style.font-size.rem]="0.75"></i>
                                }
                            </li>
                        </href>
                        }
                    </ul>
                    }
                </div>
            </div>
            <!-- Footer navigation-->
            <div class="bg-col-51 p-a p-t-3 m-t-6">
                <ul class="off-canvas-footer">
                    <li class="flex b-col-4 b-b"
                        *ifLoggedIn>
                        <a class=" flex flex-middle"
                           routerLink="/account">
                            <i class="icon-account2 p-l-2"
                               [style.font-size.px]="36"></i>
                            <span class="p2 p-l"
                                  translate>My Account</span>
                        </a>
                    </li>
                    <li class="flex b-col-4 b-b"
                        *ifNotLoggedIn>
                        <a class="flex flex-middle"
                           routerLink="/login">
                            <i class="icon-account2 p-l-2"
                               [style.font-size.px]="36"></i>
                            <span class="p2 p-l"
                                  translate>Sign in</span>
                        </a>
                    </li>
                    @for (item of content.footerLinks; track item; let isLast = $last) {
                    <li class="flex b-col-4"
                        [ngClass]="{'b-b':!isLast}">
                        @switch (item.icons === 'icon-phone') {
                        @case (false) {
                        <href class="flex flex-middle"
                              [link]="item.link">
                            <i class="p-l-2"
                               [ngClass]="item.icons"></i>
                            <span class="p2 p-l"
                                  *iCms="'text' of item"></span>
                        </href>
                        }
                        @case (true) {
                        <href class="flex flex-middle"
                              [link]="item.link"
                              [ga4TrackClick]="{
                                    name: 'phone_icon_tracking',
                                    details: {
                                        phone_icon_device: 'Mobile'
                                    }
                                 }">
                            <i class="p-l-2"
                               [ngClass]="item.icons"></i>
                            <span class="p2 p-l"
                                  *iCms="'text' of item"></span>
                        </href>
                        }
                        }
                    </li>
                    }
                </ul>
            </div>
        </div>
        <!-- level 2 -->
        @if (isVisible) {
        @for (tab of tabs; track tab) {
        <div>
            @for (item of tab.menu; track item; let i = $index) {
            <div>
                @if (client.isCms || (item.secondLevelTurnOn && item.secondLevelItems?.length)) {
                <div [zippy]="[uid, i]"
                     [zippyCloseOnEvent]="zippyCloseEventName"
                     class="ng-hide ng-hide-animate hide-right pos-absolute bg-col-w fill z-2">
                    <div class="fill flex-column overflow-y-auto scrolling-touch">
                        <div class="b-b b-col-51 p-t-6 p-b-7 pos-relative">
                            <div class="p-l-5 p-r">
                                <button class="flex flex-middle"
                                        type="button"
                                        [zippyClose]="[uid,i]">
                                    <i class="icon-arrow-left m-r-2 flex flex-middle"
                                       aria-hidden="true"></i>
                                    <span translate>Back</span>
                                </button>
                                <button class="pos-absolute top-7 right-5"
                                        type="button"
                                        [attr.aria-label]="'Close' | translate"
                                        (click)="hideOffCanvas()">
                                    <i class="icon-close s2"
                                       aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                        <div class="p-l p-r">
                            <p class="h4 b-b b-col-4 p-t-5 p-b-5"
                               *iCms="'text' of item">
                            </p>
                        </div>
                        <ul class="p-a p-t-0 menu">
                            @for (secLevelItem of item.secondLevelItems; track secLevelItem; let j = $index) {
                            <href
                                  [link]="secLevelItem.thirdLevelTurnOn && secLevelItem.thirdLevelItems?.length ? undefined : secLevelItem.link">
                                <li class="b-b b-col-4 flex flex-middle flex-justify-between"
                                    [gtmTrackNavigationClick]="{
                                            event: 'nav_subcategory_click',
                                            nav_category: item.text,
                                            nav_subcategory: secLevelItem.text}"
                                    [ngClass]="secLevelItem.color ? secLevelItem.color : 'col-1'"
                                    [zippyOpen]="[uid, i, j]"
                                    [zippyOpenOff]="!(client.isCms || (secLevelItem.thirdLevelTurnOn && secLevelItem.thirdLevelItems?.length))">
                                    <span class="p1"
                                          *iCms="'text' of secLevelItem">
                                    </span>
                                    @if (secLevelItem.thirdLevelItems?.length) {
                                    <i class="icon-chevron-right col-12 p-r-2"
                                       [style.font-size.rem]="0.75"></i>
                                    }
                                </li>
                            </href>
                            }
                        </ul>
                        <!-- Featured carousel-->
                        @for (secLevelItem of item.secondLevelItems; track secLevelItem) {
                        @if (secLevelItem.featuredHeader || secLevelItem.featuredCarousel.length > 0) {
                        <div class="p-b p-l">
                            @if (secLevelItem.featuredHeader) {
                            <p class="h4 m-t-6"
                               *iCms="'featuredHeader' of secLevelItem">
                            </p>
                            }
                            @if (secLevelItem.featuredCarousel.length > 0) {
                            <carousel class="m-t-5"
                                      [slidesPerView]="2.2"
                                      [navigation]="false"
                                      [spaceBetween]="15"
                                      [scrollbar]="false"
                                      [pagination]="false"
                                      imageViewRoot>
                                @for (carouselItem of secLevelItem.featuredCarousel; track carouselItem) {
                                <ng-template swiperSlide>
                                    <href [link]="carouselItem.link"
                                          [gtmTrackNavigationClick]="{
                                                     event: 'nav_image_click',
                                                     nav_category: item.text,
                                                     link_url: carouselItem.link,
                                                     link_text: carouselItem.text}">
                                        <div class="ratio-1-1">
                                            <img class="rf"
                                                 dynamic="1"
                                                 [image]="carouselItem.image" />
                                        </div>
                                        <p class="s1 m-t-2"
                                           *iCms="'text' of carouselItem"></p>
                                    </href>
                                </ng-template>
                                }
                            </carousel>
                            }
                        </div>
                        }
                        }
                    </div>
                </div>
                }
            </div>
            }
            <!-- level 3 -->
            @for (itemParent of tab.menu; track itemParent; let i = $index) {
            @for (item of itemParent.secondLevelItems; track item; let j = $index) {
            @if (client.isCms || (item.thirdLevelTurnOn && item.thirdLevelItems?.length)) {
            <div [zippy]="[uid, i, j]"
                 [zippyCloseOnEvent]="zippyCloseEventName"
                 class="ng-hide ng-hide-animate hide-right pos-absolute bg-col-w fill z-2">
                <div class="fill flex-column overflow-y-auto scrolling-touch">
                    <div class="b-b b-col-51 p-t-6 p-b-7 pos-relative">
                        <div class="p-l-5 p-r">
                            <button type="button"
                                    [zippyClose]="[uid, i, j]">
                                <i class="icon-arrow-left p-r-2"
                                   aria-hidden="true"></i>
                                <span>{{ 'Back to' | translate }} </span>
                                <span *iCms="'text' of itemParent"></span>
                            </button>
                            <button class="pos-absolute top-7 right-5"
                                    type="button"
                                    [attr.aria-label]="'Close' | translate"
                                    (click)="hideOffCanvas()">
                                <i class="icon-close s2"
                                   aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <div class="p-l p-r">
                        <p class="h4 b-b b-col-4 p-t-5 p-b-5"
                           *iCms="'text' of item">
                        </p>
                    </div>
                    <ul class="p-a p-t-0 menu">
                        @for (thirdLevelitem of item.thirdLevelItems; track thirdLevelitem; let j = $index) {
                        <href [link]="thirdLevelitem.link">
                            <li class="p-t-5 p-b b-b b-col-4 flex flex-middle flex-justify-between"
                                [gtmTrackNavigationClick]="{
                                            event: 'nav_subcategory_item_click',
                                            nav_category: itemParent.text,
                                            link_url: thirdLevelitem.link,
                                            link_text: thirdLevelitem.text,
                                            nav_subcategory: item.text}"
                                [ngClass]="thirdLevelitem.color ? thirdLevelitem.color : 'col-1'">
                                <span class="p1"
                                      *iCms="'text' of thirdLevelitem">
                                </span>
                            </li>
                        </href>
                        }
                    </ul>
                </div>
            </div>
            }
            }
            }
        </div>
        }
        }
    </div>
</div>
}
